module.exports = __webpack_public_path__ + "img/sjjkfkb.bf01991a.png";